import url from 'url';

const apiHost = process.env.API_HOST || '';
const userEndpoint = url.parse(`${apiHost}/api/2/user`);

export const Actions = {
    GET_USER_STARTED: '@@Layout/GET_USER_STARTED',
    GET_USER_SUCCESS: '@@Layout/GET_USER_SUCCESS',
    GET_USER_FAILURE: '@@Layout/GET_USER_FAILURE',
};

const startGetUser = () => ({
    type: Actions.GET_USER_STARTED,
});

export const getUserSuccess = user => ({
    type: Actions.GET_USER_SUCCESS,
    payload: { user },
});

const getUserFailure = () => ({
    type: Actions.GET_USER_FAILURE,
});

export function getUser() {
    return dispatch => {
        const requestUrl = url.format(userEndpoint);
        const options = {
            method: 'GET',
            credentials: 'include',
        };

        dispatch(startGetUser());

        return fetch(requestUrl, options)
            .then(response => {
                switch (response.status) {
                    case 200 || 304:
                        return response
                            .json()
                            .then(user => {
                                dispatch(getUserSuccess(user));
                                return user;
                            })
                            .catch(() => {
                                dispatch(getUserFailure());
                            });
                    default:
                        dispatch(getUserFailure());
                }
            })
            .catch(() => {
                return dispatch(getUserFailure());
            });
    };
}
